import Vue from 'vue'
import Base from './Base.vue'
import { store } from './store';
import '@progress/kendo-ui'
//import '@progress/kendo-theme-default/dist/all.css'

import { Button, ButtonGroup, ToolBar, ToolBarItem, ButtonGroupButton, ButtonsInstaller } from '@progress/kendo-buttons-vue-wrapper';

import { router } from './router'
import { dom } from '@fortawesome/fontawesome-svg-core'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas  } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import ExcelExport from "./helpers/ExcelExport"
//dom.watch();

library.add(fas);
Vue.config.productionTip = false;
Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.use(ButtonsInstaller);
kendo.cultures["sl-SI"]={name:"sl-SI",numberFormat:{pattern:["-n"],decimals:2,",":".",".":",",groupSize:[3],percent:{pattern:["-n%","n%"],decimals:2,",":".",".":",",groupSize:[3],symbol:"%"},currency:{pattern:["-n $","n $"],decimals:2,",":".",".":",",groupSize:[3],symbol:"€"}},calendars:{standard:{days:{names:["nedelja","ponedeljek","torek","sreda","četrtek","petek","sobota"],namesAbbr:["ned","pon","tor","sre","čet","pet","sob"],namesShort:["ne","po","to","sr","če","pe","so"]},months:{names:["januar","februar","marec","april","maj","junij","julij","avgust","september","oktober","november","december",""],namesAbbr:["jan","feb","mar","apr","maj","jun","jul","avg","sep","okt","nov","dec",""]},AM:[""],PM:[""],patterns:{d:"d.M.yyyy",D:"d. MMMM yyyy",F:"d. MMMM yyyy H:mm:ss",g:"d.M.yyyy H:mm",G:"d.M.yyyy H:mm:ss",m:"d. MMMM",M:"d. MMMM",s:"yyyy'-'MM'-'dd'T'HH':'mm':'ss",t:"H:mm",T:"H:mm:ss",u:"yyyy'-'MM'-'dd HH':'mm':'ss'Z'",y:"MMMM yyyy",Y:"MMMM yyyy"},"/":".",":":":",firstDay:1}}};

kendo.culture("sl-SI");
window.bus = new Vue();


Vue.use(ExcelExport);


fetch(process.env.BASE_URL + "config.json")
  .then((response) => response.json())
  .then((config) => {
    //	console.log(json);
	Vue.prototype.$config = config
	  
Vue.mixin({
  data: function() {
    return {
      privzetaSezona:"Izberi sezono!",
      version:"1.0.2"
    }
  },
  methods:{
    nazaj(){

      this.$router.push({ name: 'pridelava', params: this.dataSezona });

   },
     nazajPredelava(){

      this.$router.push({ name: 'predelava', params: this.dataSezona });

   }
  }
});


	new Vue({
		beforeCreate: function() {
    console.log(this.$config)
  },
    el: '#app',
    
    router,
    config,
    store,
    render: h => h(Base)
	});


    /*new Vue({
    el: '#app',
	router: router,
    template: '<App/>',
    components: {
        App,
       DropDownList
    }
	});  
	*/
//})
});
